/* src/app/components/submission-history/submission-history.component.scss */
.bottom-padding {
  padding-bottom: 100px;
}
.bottom-padding-small {
  padding-bottom: 30px;
}
.inventory-tab-span {
  font-size: 25px;
  font-weight: bold;
}
.nav > li {
  margin-left: 0;
}
.nav-link.active,
.nav > li > a:focus,
.nav > li > a:hover {
  background-color: #0071bb;
  color: #fff;
}
.hidden {
  display: none;
}
.e-datepicker {
  pointer-events: none;
}
.save-grid-button {
  position: absolute;
  right: 15px;
  top: 92px;
  z-index: 1000;
}
button#approveselected,
button#validateselected,
button#downloadlog,
button#submissionhistory {
  border-radius: 0;
  height: 30px;
  width: auto;
  background-color: #0071bb;
}
button#approveselected span,
button#validateselected span,
button#downloadlog span,
button#submissionhistory span {
  color: #fff;
  border: none;
}
button#approveselected:hover,
button#validateselected:hover,
button#downloadlog:hover,
button#submissionhistory:hover {
  background-color: #009bd6;
  border-color: transparent;
  transition: 0.5s;
}
.e-checkbox-wrapper,
.e-css.e-checkbox-wrapper {
  -webkit-tap-highlight-color: transparent;
  padding-left: 5px;
}
.e-grid .e-rowcell .e-checkbox-wrapper,
.e-grid .e-rowcell .e-css.e-checkbox-wrapper {
  padding-left: 5px;
}
.e-control,
.e-css {
  font-size: 14px !important;
  font-weight: normal;
}
.tooltip-span {
  padding: 3px 20px;
}
#dialog .panel-footer {
  text-align: center;
  background-color: #ffffff;
  border-top: none;
  padding-bottom: 20px;
}
#dialog .panel-footer button {
  margin: 10px;
}
.p-no-margin {
  margin: 0;
}
.e-filterbar {
  display: none;
}
.checkbox-header-manage-di {
  border-right: solid 0px #fff !important;
}
#dialog_dialog-content {
  padding: 0 !important;
}
/*# sourceMappingURL=submission-history.component.css.map */
